export default __webpack_public_path__ + "images/8e7a0fb9f0b781582eed8887cf49604e.png";